var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-auto row col-12 bg-secondary-1 px-1 m-0" },
    [
      _c(
        "div",
        {
          staticClass:
            "col d-flex align-items-center bg-white my-2 mx-1 px-5 py-3"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "custom-circle-loader-container d-flex align-items-center"
            },
            [
              _c("circle-loader", {
                attrs: {
                  "circle-class": "custom-circle-loader",
                  "inner-text": `${_vm.catalog.pendings}%`,
                  "loader-color": "#FDAC41",
                  percentage: _vm.catalog.pendings
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "text-dark-midnight" }, [
            _vm._v("Cuestionarios Pendientes")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "col d-flex align-items-center bg-white my-2 mx-1 px-5 py-3"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "custom-circle-loader-container d-flex align-items-center"
            },
            [
              _c("circle-loader", {
                attrs: {
                  "circle-class": "custom-circle-loader",
                  "inner-text": `${_vm.catalog.completed}%`,
                  percentage: _vm.catalog.completed
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "text-dark-midnight" }, [
            _vm._v("Cuestionarios Completados")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "col d-flex align-items-center bg-white my-2 mx-1 px-5 py-3"
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 counter" }, [
              _vm._v(
                " " +
                  _vm._s(_vm._f("formatNumber")(_vm.catalog.totalCompleted)) +
                  " "
              )
            ]),
            _c("div", { staticClass: "col-12 text-dark-midnight" }, [
              _vm._v(" Cantidad de Cuestionarios Completados ")
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }